import { render, staticRenderFns } from "./RecruitLink.vue?vue&type=template&id=afa5e7bc&scoped=true&"
import script from "./RecruitLink.vue?vue&type=script&lang=js&"
export * from "./RecruitLink.vue?vue&type=script&lang=js&"
import style0 from "./RecruitLink.vue?vue&type=style&index=0&id=afa5e7bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa5e7bc",
  null
  
)

export default component.exports